import { render, staticRenderFns } from "./DocumentDrawer.vue?vue&type=template&id=077bd9bd"
import script from "./DocumentDrawer.vue?vue&type=script&lang=js"
export * from "./DocumentDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports